import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import AddSurvey from "./AddSurvey/AddSurvey";
import List from "components/list/List";

import SurveyFilterContainer from "./SurveyFilterContainer";
import SurveyPaginationContainer from "./SurveyPaginationContainer";
import SurveyRangePickerContainer from "./SurveyRangePickerContainer";
import { surveyColumns, surveyFilters, rangeDatePickerFilter } from "./SurveyListGrid.utils";

class SurveyListGrid extends PureComponent {
  state = {
    surveyList: this.props.surveyList,
    sectorList: this.props.sectorList
  };

  componentDidMount() {
    this.props.setSurvey();
  }

  render() {
    const { setArchiveSurvey, getSurveySorted, deleteSurvey, surveyListLoading } = this.props;

    return (
      <div class="p-content-page-center p-content-page-center-full" style={{ height: "calc(100% - 77px" }}>
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Liste des questionnaires</h2>
          <div class="p-content-page-center-header-buttons">
            <div class="p-content-page-center-header-buttons-item">
              <AddSurvey />
            </div>
          </div>
        </div>
        <div className="p-content-page-center-filters">
          <div className="p-mrg-right">
            <SurveyRangePickerContainer filterTargetKey={rangeDatePickerFilter.targetKey} />
          </div>
          {surveyFilters.map(filter => (
            <div className="p-mrg-right" style={{ width: "150px" }}>
              <SurveyFilterContainer
                key={filter.idKey}
                filterTargetKey={filter.targetKey}
                filterIdKey={filter.idKey}
                filterLabelKey={filter.labelKey}
                placeholder={filter.placeholder}
                defaultValue={this.props.currentFilters[filter.defaultValue]}
              />
            </div>
          ))}
        </div>
        <div class="p-content-page-center-content">
          <List
            loading={surveyListLoading}
            columns={surveyColumns(setArchiveSurvey, getSurveySorted, deleteSurvey)}
            data={this.props.surveyList}
            page={this.props.page}
            pages={this.props.pages}
            defaultText="Aucun questionnaire trouvé."
          />
          <div className="p-al-right p-mrg-ver p-mrg-bot-l">
            <SurveyPaginationContainer />
          </div>
        </div>
      </div>
    );
  }
}

SurveyListGrid.propTypes = {
  surveyList: PropTypes.array,
  sectorList: PropTypes.array,
  currentFilters: PropTypes.object,
  setArchiveSurvey: PropTypes.function,
  getSurveySorted: PropTypes.function,
  setSurvey: PropTypes.function
};

export default SurveyListGrid;



// WEBPACK FOOTER //
// src/components/survey/gestion/SurveyList/SurveyListGrid/SurveyListGrid.js